import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

export function useHiddenRequests(userId: string | undefined) {
  const [hiddenRequests, setHiddenRequests] = useState<Set<string>>(new Set());
  const [hiddenRequestsList, setHiddenRequestsList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) {
      setHiddenRequests(new Set());
      return;
    }
    fetchHiddenRequestsSet();
  }, [userId]);

  async function fetchHiddenRequestsSet() {
    try {
      const { data, error } = await supabase
        .from('insurer_actions')
        .select('request_id')
        .eq('insurer_id', userId)
        .eq('action', 'hidden');

      if (error) throw error;
      setHiddenRequests(new Set(data?.map(item => item.request_id) || []));
    } catch (error) {
      setHiddenRequests(new Set());
    }
  }

  async function fetchHiddenRequests() {
    try {
      setLoading(true);
      const { data, error } = await supabase.rpc('get_hidden_requests');
      if (error) throw error;
      setHiddenRequestsList(data || []);
    } catch (error) {
      console.error('Error fetching hidden requests:', error);
    } finally {
      setLoading(false);
    }
  }

  return {
    hiddenRequests,
    hiddenRequestsList,
    loading,
    fetchHiddenRequests,
    fetchHiddenRequestsSet
  };
}